import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "lsc_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setTimeout(() => setVisible(true), 800);
  }, []);
  const accept = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: Date.now() }));
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-[#1A1815] text-[#F5EFE4] border border-[#C5A059] p-6 shadow-2xl">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <p className="text-[10px] uppercase tracking-[0.24em] text-[#C5A059] font-medium">Cookies</p>
          <p className="mt-2 text-sm text-[#F5EFE4]/90 leading-relaxed">
            We use essential cookies to run the site and optional analytics to improve it.
            Read our <Link to="/cookies" className="text-[#C5A059] hover:underline">Cookie Policy</Link>.
          </p>
        </div>
        <button onClick={() => accept("essential")} aria-label="dismiss" className="text-[#F5EFE4]/50 hover:text-[#F5EFE4]"><X size={16} /></button>
      </div>
      <div className="mt-5 flex gap-3">
        <button onClick={() => accept("essential")} data-testid="cookie-essential" className="flex-1 luxor-btn-outline-light justify-center text-[10px]">Essential only</button>
        <button onClick={() => accept("all")} data-testid="cookie-accept-all" className="flex-1 luxor-btn-primary justify-center text-[10px]">Accept all</button>
      </div>
    </div>
  );
}
